export const themeEditorUiConfigClock = [
  {
    sectionName: "Content Blocks - Clock",
    sectionKey: "contentBlocks.clock",
    description: "Styling for clock content block type",
    groups: [
      {
        groupName: "Container",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.clock.container.color",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Clock default text color",
            options: {
              allowInherit: true,
              modalTitle: "Clock Time Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.clock.container.background",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Clock background color",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.clock.container.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Clock default font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.clock.container.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Clock default font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.clock.container.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Clock default font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Time",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.clock.time.color",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Clock time text color",
            options: {
              allowInherit: true,
              modalTitle: "Clock Time Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.clock.time.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Location badge font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.clock.time.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Clock time font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.clock.time.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Clock time font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Weekday",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.clock.weekday.color",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Weekday text color",
            options: {
              allowInherit: true,
              modalTitle: "Weekday Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.clock.weekday.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Month font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.clock.weekday.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Month font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.clock.weekday.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Month font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Month",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.clock.month.color",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Month text color",
            options: {
              allowInherit: true,
              modalTitle: "Clock Month Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.clock.month.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Month font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.clock.month.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Month font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.clock.month.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Month font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Year",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.clock.year.color",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Month text color",
            options: {
              allowInherit: true,
              modalTitle: "Clock Year Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.clock.year.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Month font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.clock.year.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Month font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.clock.year.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Month font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
    ],
  },
];
